var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.618,
    height: 24.618,
    viewBox: "0 0 24.618 24.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1342.75 -160.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.741,24.118h6.635c5.53,0,7.741-2.212,7.741-7.741V9.741C24.118,4.212,21.906,2,16.377,2H9.741C4.212,2,2,4.212,2,9.741v6.635C2,21.906,4.212,24.118,9.741,24.118Z",
    transform: "translate(1342 160)",
    fill: "rgba(33,156,250,0.1)",
    stroke: "#219cfa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1350.633 173.059) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.259,6.259,0",
    fill: "none",
    stroke: "#219cfa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.259,6.259,0,0",
    fill: "none",
    stroke: "#219cfa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.5488a85d58828f64a07892eb7d630f11.svg";
export { ForwardRef as ReactComponent };